import React from "react";
import { Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { ArrowBack } from "@material-ui/icons";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getParameterByName, handleError, qs } from "../../shared/utility";
import axios from "store/axios/axios-rs";
import axios_invoice from "store/axios/axios-invoice";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import * as actions from "../../store/actions";
import InvoiceForm from "../../containers/Invoices/InvoiceForm";
import InvoiceFormWizard from "../../containers/Invoices/InvoiceFormWizard";
import InvoiceList, { INVOICE_VIEW_FILTERS_MODULE, INVOICE_COLUMNS_META } from "../../containers/Invoices/InvoiceList";
import { ViewFiltersButton } from "../../components/ViewFiltersModal/useViewFilters";
import checkPermissions from "../../shared/checkPermissions";
import checkPermissionsActions from "../../shared/checkPermissionsActions";
import { INVOICE_STATUS } from "../../containers/Invoices/InvoiceObj";
import CustomDialogRSChooser from "../../components/CustomDialog/CustomDialogRSChooser";
import InvoiceEditor from "../../containers/Invoices/InvoiceEditor";

class InvoicesPage extends React.Component {
    state = {
        tab: "",
        subFilter: "all",
        openedForm: false,
        action: "Edit",
        parentData: null,
        openPDFitemID: null,
        openedChooseRS: false,
        openedInvoiceEditor: null,
        hiddenColumns: []
    };

    setTab = (tab) => this.setState({ tab });

    openForm = () => this.setState({ openedForm: true });
    closeForm = () => this.setState({ openedForm: false });

    setParentData = (data) =>
        this.setState({ parentData: data, action: "Edit" });

    openRS = (rs) => {
        this.setState({
            openedInvoiceEditor: rs,
            openedChooseRS: false,
            tab: INVOICE_STATUS.NEW
        });
    }

    loadRS = async (rs_id) => {
        try {
            const response = await axios.get('/rsheet?id='+rs_id);
            if (response.data) {
                this.openRS(response.data);
            }
        } catch(e) {
            handleError(e);
        }
    }

    loadInvoice = async (invoice_id) => {
        try {
            const response = await axios_invoice.get('/entries?invoice_id='+invoice_id);
            if (response.data) {
                console.log('loaded invoice', response.data)
                // TO DO: What should tab be depending on invoice
                const invoices = response.data;
                if (invoices.length > 0) {
                    this.setState({
                        parentData: invoices[0],
                        openedForm: true,
                        tab: invoices[0].status
                    })
                }
            }
        } catch(e) {
            handleError(e);
        }
    }

    componentDidMount() {
        const { getInvoiceEntries } = this.props;
        const queryParams = qs(this.props.location.search);
        if (queryParams.tab) {
            if (INVOICE_STATUS[queryParams.tab.toUpperCase()]) {
                this.setTab(INVOICE_STATUS[queryParams.tab.toUpperCase()]);
                if (queryParams.invoice_id) {
                    this.setState({
                        openPDFitemID: queryParams.invoice_id
                    });
                }
            }
        } else {
            this.setTab(INVOICE_STATUS.ALL);
        }

        const action = getParameterByName('p', window.location.href);
        if (action) {
            const permitted = checkPermissions("Invoice");
            if (permitted) {
                const rs_id = getParameterByName('rs_id', window.location.href);
                if (rs_id) {
                    window.history.replaceState(null, null, '/invoices');
                    this.loadRS(rs_id);
                    this.setTab(INVOICE_STATUS.NEW);
                } else {
                    const invoice_id = getParameterByName('invoice_id', window.location.href);
                    if (invoice_id) {
                        this.loadInvoice(invoice_id);
                    }
                }
            }
        }
    }


    
    render() {
        const {
            entriesData,
            invoicePdf,
            getInvoiceEntries,
            createInvoiceEntry,
            updateInvoiceEntry,
            deleteInvoiceEntry,
            getInvoicePdf,
            getRsheet,
            rsheetData,
            resetRsData,
            clearInvoicePdfData,
            clearRSheets,
            resendInvoiceEmail,
            success,
        } = this.props;
        const { action, openedForm, tab, parentData } = this.state;

        const pmaPermitted = checkPermissions("Invoice");
        if (!pmaPermitted) {
            return <Redirect to="/dashboard" />;
        }

        const permissions = checkPermissionsActions("Invoice");
        const pr_permitted = checkPermissions('PR');

        console.log('InvoicesPage', this.state);

        return (
            <div style={{ marginTop: 20 }}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="rose" icon>
                                <CardIcon
                                    color={tab === INVOICE_STATUS.ALL ? "success" : "rose"}
                                    onClick={() => {
                                        this.setState({ tab: INVOICE_STATUS.ALL, subFilter: 'all' });
                                    }}
                                    className="hovered"
                                >
                                    <strong>ALL</strong>
                                </CardIcon>
                                <CardIcon
                                    color={
                                        tab === INVOICE_STATUS.NEW
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={() => {
                                        const should = !this.state.openedInvoiceEditor ? true : false;
                                        this.setState({
                                            openedChooseRS: should,
                                            tab: INVOICE_STATUS.NEW
                                        })
                                    }}
                                    className="hovered"
                                >
                                    <strong>Choose RS</strong>
                                </CardIcon>
                                <CardIcon
                                    color={
                                        tab === INVOICE_STATUS.PENDING
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={() => {
                                        this.props.history.push('/invoices?tab=pending');
                                        this.setTab(INVOICE_STATUS.PENDING);
                                    }}
                                    className="hovered"
                                >
                                    <strong>Pending</strong>
                                </CardIcon>
                                <CardIcon
                                    color={
                                        tab === INVOICE_STATUS.APPROVED
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={() => {
                                        this.props.history.push('/invoices?tab=approved');
                                        this.setTab(INVOICE_STATUS.APPROVED);
                                    }}
                                    className="hovered"
                                >
                                    <strong>Approved</strong>
                                </CardIcon>
                                <CardIcon
                                    color={
                                        tab === INVOICE_STATUS.DECLINE
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={() => {
                                        this.props.history.push('/invoices?tab=declined');
                                        this.setTab(INVOICE_STATUS.DECLINE);
                                    }}
                                    className="hovered"
                                >
                                    <strong>Declined</strong>
                                </CardIcon>
                                <CardIcon
                                    color={
                                        tab === INVOICE_STATUS.VOIDED
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={() => {
                                        this.props.history.push('/invoices?tab=voided');
                                        this.setTab(INVOICE_STATUS.VOIDED);
                                    }}
                                    className="hovered"
                                >
                                    <strong>Voided</strong>
                                </CardIcon>
                            </CardHeader>
                            <CardBody>
                                <div>
                                    {tab === INVOICE_STATUS.ALL && <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, marginTop: 10, marginBottom: 10 }}>
                                        <div style={{ maxWidth: 360, flex: '0 0 360px' }}>
                                            <CustomSelect
                                                label="Filter"
                                                default={this.state.subFilter || 'all'}
                                                options={[
                                                    { value: 'all', desc: 'All' },
                                                    { value: 'pending', desc: 'Pending' },
                                                    { value: 'approved', desc: 'Approved' },
                                                    { value: 'declined', desc: 'Declined' },
                                                    { value: 'voided', desc: 'Voided' },
                                                    { value: 'draft', desc: 'Drafts' }
                                                ]}
                                                choose={(val) => { this.setState({ subFilter: val }); }}
                                                indx="value"
                                                desc="desc"
                                            />
                                        </div>
                                        <ViewFiltersButton
                                            moduleName={INVOICE_VIEW_FILTERS_MODULE}
                                            columns={INVOICE_COLUMNS_META}
                                            tab={this.state.subFilter || 'all'}
                                            onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                                        />
                                    </div>}
                                    {tab !== INVOICE_STATUS.ALL && tab !== INVOICE_STATUS.NEW && <div style={{ marginTop: 10, marginBottom: 10 }}>
                                        <ViewFiltersButton
                                            moduleName={INVOICE_VIEW_FILTERS_MODULE}
                                            columns={INVOICE_COLUMNS_META}
                                            tab={String(tab)}
                                            onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                                        />
                                    </div>}
                                    {(tab && tab !== INVOICE_STATUS.NEW) && <InvoiceList
                                        tab={tab}
                                        subFilter={this.state.subFilter}
                                        hiddenColumns={this.state.hiddenColumns}
                                        setTab={this.setTab}
                                        data={entriesData}
                                        openForm={this.openForm}
                                        setParentData={this.setParentData}
                                        parentData={this.state.parentData}
                                        deleteInvoiceEntry={deleteInvoiceEntry}
                                        getInvoiceEntries={getInvoiceEntries}
                                        getInvoicePdf={getInvoicePdf}
                                        pdfData={invoicePdf}
                                        updateInvoiceEntry={updateInvoiceEntry}
                                        openPDFitemID={this.state.openPDFitemID}
                                        resetInvoiceID={this.props.resetInvoiceID}
                                        resetOpenPDFitemID={() => {
                                            this.setState({
                                                openPDFitemID: null
                                            })
                                        }}
                                        clearInvoicePdfData={clearInvoicePdfData}
                                        resendInvoiceEmail={resendInvoiceEmail}
                                        success={success}
                                        permissions={permissions ? Object.keys(permissions) : []}

                                        createInvoicePayment={this.props.createInvoicePayment}
                                        updateInvoicePayment={this.props.updateInvoicePayment}
                                        getInvoicePayments={this.props.getInvoicePayments}
                                        invoicePayments={this.props.invoicePayments}
                                        pr_permitted={pr_permitted}
                                    />}

                                    {(this.state.openedInvoiceEditor && tab === INVOICE_STATUS.NEW) && <>
                                        <Button color="primary" onClick={() => {
                                            this.setState({
                                                openedChooseRS: true,
                                                tab: INVOICE_STATUS.NEW
                                            })
                                        }}>
                                            Open another RS
                                        </Button>
                                        <InvoiceEditor 
                                            data={this.state.openedInvoiceEditor.json_data}
                                            entryData={this.state.openedInvoiceEditor}
                                        />
                                    </>}
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

                <Dialog
                    open={openedForm}
                    onClose={this.closeForm}
                    fullWidth={true}
                    maxWidth={false}
                    fullScreen={true}
                >
                    <div className="dialog-wrapper">
                        <div
                            style={{ marginRight: 20, marginBottom: 10 }}
                            className="blue-text hoverable"
                            onClick={this.closeForm}
                        >
                            <Tooltip
                                id="tooltip-top-start1"
                                title="Back to List"
                                placement="top"
                            >
                                <ArrowBack />
                            </Tooltip>
                        </div>
                        <InvoiceForm
                            action={action}
                            parentData={parentData}
                            setParentData={this.setParentData}
                            createInvoiceEntry={createInvoiceEntry}
                            updateInvoiceEntry={updateInvoiceEntry}
                            closeForm={this.closeForm}
                            getInvoiceEntries={getInvoiceEntries}
                            getInvoicePdf={getInvoicePdf}
                            pdfData={invoicePdf}
                            rsheetData={rsheetData}
                            getRsheet={getRsheet}
                            clearRSheets={clearRSheets}
                            listStatus={tab}
                            clearInvoicePdfData={clearInvoicePdfData}
                            permissions={permissions ? Object.keys(permissions) : []}
                            invoicePayments={this.props.invoicePayments}
                            error={this.props.error}
                            success={this.props.success}
                            tab={this.state.tab}
                        />
                    </div>
                </Dialog>

                {this.state.openedChooseRS && <CustomDialogRSChooser 
                        open={true}
                        close={() => {
                            this.setState({
                                openedChooseRS: false
                            })
                        }}
                        openRS={this.openRS}
                    />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        entriesData: state.invoice.entriesData,
        error: state.invoice.error,
        success: state.invoice.success,
        loading: state.invoice.loading,
        invoicePdf: state.invoice.invoicePdf,
        rsheetData: state.rs.rsheetData,
        invoicePayments: state.invoice.invoicePayments,
        success_payments: state.invoice.success_payments,
        error_payments: state.invoice.error_payments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoiceEntries: (status, filtersObj) => {
            dispatch(actions.getInvoiceEntries(status, null, filtersObj));
        },
        createInvoiceEntry: (data) => {
            dispatch(actions.createInvoiceEntry(data));
        },
        updateInvoiceEntry: (data) => {
            dispatch(actions.updateInvoiceEntry(data));
        },
        deleteInvoiceEntry: (id) => {
            dispatch(actions.deleteInvoiceEntry(id));
        },
        getInvoicePdf: (html) => {
            dispatch(actions.getInvoicePdf(html));
        },
        clearInvoicePdfData: () => {
            dispatch(actions.clearInvoicePdfData());
        },
        resendInvoiceEmail: (data) => {
            dispatch(actions.resendInvoiceEmail(data))
        },
        getRsheet: (id) => dispatch(actions.getRsheet(id)),
        resetRsData: () => dispatch(actions.getRsheetStart()),
        resetInvoiceID: () => dispatch(actions.resetInvoiceID()),
        clearRSheets: () => dispatch(actions.clearRSheets()),

        getInvoicePayments: (data) => {
            dispatch(actions.getInvoicePayments(data));
        },
        createInvoicePayment: (data) => {
            dispatch(actions.createInvoicePayment(data));
        },
        updateInvoicePayment: (data) => {
            dispatch(actions.updateInvoicePayment(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesPage);
